exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody {\n    margin: 0px;\n    padding: 0px;\n}\n#app {\n    /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/\n    /*-webkit-font-smoothing: antialiased;*/\n    /*-moz-osx-font-smoothing: grayscale;*/\n    /*!*text-align: center;*!*/\n    /*color: #2c3e50;*/\n    /*!*margin-top: 60px;*!*/\n}\n", ""]);

// exports
